import { z } from "zod";
import { Country } from "models/country/Country";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const Countries = z.object({
    countries: Country.array(),
});

export type Countries = z.infer<typeof Countries>;
